import React from "react";
import PropTypes from "prop-types";
import themeGet from "@styled-system/theme-get";
import { StyledLink } from "orcs-design-system";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const CustomStyledLink = styled(StyledLink)`
  transition: ${themeGet("transition.transitionDefault")};
  border-radius: ${themeGet("radii.2")};
  padding: ${themeGet("space.s")};
  color: ${(props) => themeGet("colors.bodyText")(props)};

  ${(props) =>
    props.$isActive &&
    `
    background-color: ${themeGet("colors.navActiveBackground")(props)};
  `}

  &:hover,
  &:focus {
    text-decoration: none;
    color: ${themeGet("colors.bodyText")};
    background-color: ${(props) =>
      props.$isActive
        ? themeGet("colors.navActiveBackground")(props)
        : themeGet("colors.hoverSurface")(props)};
  }
`;

const SettingsLink = ({ to, id, indented, children, isActive }) => {
  const location = useLocation();
  // Check if the current location matches the 'to' prop
  const active = isActive?.(location.pathname) || location.pathname === to;

  // Render the design system's Link component with the added style
  return (
    <CustomStyledLink
      id={id}
      to={to}
      display="block"
      my="xs"
      fontSize={indented ? "1" : "2"}
      ml={indented ? "s" : "0"}
      $isActive={active}
    >
      {children}
    </CustomStyledLink>
  );
};

SettingsLink.propTypes = {
  to: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  indented: PropTypes.bool,
  isActive: PropTypes.func,
};

export default SettingsLink;
